// @ts-nocheck
import React from 'react'
import * as R from 'ramda'

import {
  ChoiceValueInput,
  MetricInput,
  PublishedAsTestimonialInput,
  SentimentInput,
  SentimentDropdown,
  TopicSentimentInput,
  EmailEventInput,
  LanguageInput,
} from 'organisms/FeedbackFilterGroup/container'
import CustomerLanguageInput from 'components/CustomerLanguageInput'
import FilterInput from 'components/FilterInput'
import FilterMultipleValueInputContainer from 'components/FilterMultipleValueInput/container'

/** @typedef {import('shared/components/FilterGroup/reducer').Filter} Filter */
/** @typedef {import('shared/components/FilterGroup/container').Extra} Extra */

/** @param {import('shared/components/FilterGroup/reducer').InputProps<Extra>} props */
export default function CustomFilterValueInputForIsComparison({
  rule,
  defaultFilters,
  onChange,
  onClose,
  onExtraChange,
  isMultipleValue = true,
}) {
  const field = R.prop('field', rule)
  if (field === 'choice_value') {
    return <ChoiceValueInput defaultFilters={defaultFilters} onChange={onChange} />
  } else if (field === 'sentiment') {
    return <SentimentInput defaultFilters={defaultFilters} onChange={onChange} />
  } else if (field === 'topic.sentiment') {
    return <TopicSentimentInput defaultFilters={defaultFilters} onChange={onChange} />
  } else if (field === 'email_event') {
    return <EmailEventInput defaultFilters={defaultFilters} onChange={onChange} />
  } else if (field === 'language') {
    return <LanguageInput defaultFilters={defaultFilters} onChange={onChange} />
  } else if (field === 'customer.language') {
    return <CustomerLanguageInput defaultFilters={defaultFilters} onChange={onChange} />
  } else if (field === 'topic.pair.sentiment') {
    return (
      <React.Fragment>
        <FilterMultipleValueInputContainer
          rule={rule}
          defaultFilters={defaultFilters}
          onChange={onChange}
        />

        <div className="mt-2">
          <SentimentDropdown
            value={R.path(['extra', 'attribute'], rule)}
            onChange={(data) => {
              onExtraChange({ attribute: data })
            }}
          />
        </div>
      </React.Fragment>
    )
  } else if (field === 'metric') {
    return <MetricInput defaultFilters={defaultFilters} onChange={onChange} />
  } else if (['comment', 'ticket_id', 'ip'].includes(field)) {
    return <FilterInput defaultFilters={defaultFilters} onChange={onChange} onClose={onClose} />
  } else if (field === 'published_as_testimonial') {
    return <PublishedAsTestimonialInput defaultFilters={defaultFilters} onChange={onChange} />
  } else {
    return (
      <FilterMultipleValueInputContainer
        rule={rule}
        defaultFilters={defaultFilters}
        onChange={onChange}
        isMultipleValue={isMultipleValue}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomFilterValueInputForIsComparison/index.js